import { terUtilsGetIdentEliminatorKapi, terUtilsNumberRoundUp, terUtilsUnitsMilimetriToMetri } from './ter-utils';
import { XIF, ROUNDUP, ROUNDDOWN } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { DOT, SLASH, SPACE } from '../utils/frfr-string-consts';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { draftel_codecs_pack_terkk$_bundle_eliminatorkapi } from './ter-draftel-codec-lib-terkk-bundle-eliminatorkapi';


export const derivat_bundle_eliminatorkapi_pripremi_pods_input_inherited_za_draftel = (virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_eliminatorkapi.default_pods_input_state(),
    msirinaunutrasnja: virtel_m.msirinaunutrasnja,
    mvisinaunutrasnja: virtel_m.mvisinaunutrasnja,
    "_extra_siframodula": null, // NOVO 2025-03-18
  };
  return pods_input_inherited;
};


/*
export const derivatPoluproizvod_eliminatorkapi_dopuni = (p) => {
  // SPECIJALNI KORAK
  // _____ dodajemo neke podatke koji su mu potrebni!

};
*/


/*
export const derivatAutoCreateVirtel_eliminatorkapiIdent = (p) => {
  let calculated_ident = terUtilsGetIdentEliminatorKapi(p)
  return calculated_ident;
};
*/


// export const _derivat_terkk_eliminatorkapi_izracunaj_za_subform_arr = (m, k) => {
export const _derivat_terkk_eliminatorkapi_izracunaj_za_subform_arr = (sirinaModula, visinaModula) => {
  console.log('sirinaModula, visinaModula', sirinaModula, visinaModula);
  let eliminatorKapiArr = [];

  if (sirinaModula > 609) { // FIX da bismo bili sigurni da ce ostala poredjenja >= biti matematicka
    if (sirinaModula === 610 || sirinaModula === 915 || sirinaModula === 1220) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 1,
          sirina: sirinaModula,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 1525) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 1,
          sirina: 610,
          visina: visinaModula - 5
        },
        {
          tempkey: 2,
          kolicina: 1,
          sirina: 915,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 1830) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 2,
          sirina: 915,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 2135) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 1,
          sirina: 915,
          visina: visinaModula - 5
        },
        {
          tempkey: 2,
          kolicina: 1,
          sirina: 1220,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 2440) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 2,
          sirina: 1220,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 2745) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 3,
          sirina: 915,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 3050) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 2,
          sirina: 915,
          visina: visinaModula - 5
        },
        {
          tempkey: 2,
          kolicina: 1,
          sirina: 1220,
          visina: visinaModula - 5
        }
      );
    } else if (sirinaModula === 3355) {
      eliminatorKapiArr.push(
        {
          tempkey: 1,
          kolicina: 1,
          sirina: 915,
          visina: visinaModula - 5
        },
        {
          tempkey: 2,
          kolicina: 2,
          sirina: 1220,
          visina: visinaModula - 5
        }
      );
    } else {

      if (sirinaModula < 1220) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 1,
            sirina: sirinaModula,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 1220 && sirinaModula < 1830) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 2,
            sirina: sirinaModula / 2,
            visina: visinaModula - 5
          }
        );
      } else if (sirinaModula >= 1830 && sirinaModula < 2135) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 2,
            sirina: sirinaModula / 2,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 2135 && sirinaModula < 2440) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 2,
            sirina: sirinaModula / 2,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 2440 && sirinaModula < 2745) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 2,
            sirina: sirinaModula / 2,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 2745 && sirinaModula < 3050) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 3,
            sirina: sirinaModula / 3,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 3050 && sirinaModula < 3355) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 3,
            sirina: sirinaModula / 3,
            visina: visinaModula - 5
          }
        )
      } else if (sirinaModula >= 3355) {
        eliminatorKapiArr.push(
          {
            tempkey: 1,
            kolicina: 4,
            sirina: sirinaModula / 4,
            visina: visinaModula - 5
          }
        )
      }

    }
  }
  //
  return {
    _arr: eliminatorKapiArr,
  };
};


export const derAutoCreateVirbom_terkk_eliminatorkapi_prepare_vir_input = (p) => {

  // promenljive iz excela
  const G19 = p.visina;
  const F19 = p.sirina;
  // const E9 = p.sirina;
  const kolicina = p.kolicina;

  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    // visina: G19,
    visinaelk: p.visina,
    // sirina: F19,
    sirinaelk: F19,
    kolicina: kolicina
  };
  return v_input;
};

export const derAutoCreateVirbom_terkk_eliminatorkapi_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_eliminatorkapi_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // let _materijal_naziv = '';

  // promenljive iz excela
  const G19 = v_input.visinaelk;
  const F19 = v_input.sirinaelk;
  const E9 = v_input.sirinaelk;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivat 1 duzina =G19-44
  // derivat 1
  // derivat local 1
  _derivat_key = "P 110";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$derivat1',
    virtelclass: "terkk$eliminatorkapi$profil",
    kolicina: 1,
  };
  x.duzina = G19 - 44;
  // x.calculated_ident = 'PP110AA000006000';
  x.calculated_ident = 'PP110AA00000';
  x.naziv = 'PROFIL AL ELIMINATOR KAPI P 110  P110 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = x.calculated_ident;
  x = {
    ...x,
    ..._getParamsFromLib("terkk$eliminatorkapi$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 1.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_eliminatorkapi_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 2 duzina =G19-44
  // derivat local 2
  _derivat_key = "P 111";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$derivat1',
    virtelclass: "terkk$eliminatorkapi$profil",
    kolicina: 1,
  };
  x.duzina = G19 - 44;
  // x.calculated_ident = 'PP111AA000006000';
  x.calculated_ident = 'PP111AA00000';
  x.naziv = 'PROFIL AL ELIMINATOR KAPI P 111  P111 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = x.calculated_ident;
  x = {
    ...x,
    ..._getParamsFromLib("terkk$eliminatorkapi$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 2.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_eliminatorkapi_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 3 duzina =F19-60
  // derivat local 3
  _derivat_key = "P 112";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$derivat1',
    virtelclass: "terkk$eliminatorkapi$profil",
    kolicina: 2,
  };
  x.duzina = F19 - 60;
  // x.calculated_ident = 'PP112AA000006000';
  x.calculated_ident = 'PP112AA00000';
  x.naziv = 'PROFIL AL ELIMINATOR KAPI P 112  P112 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = x.calculated_ident;
  x = {
    ...x,
    ..._getParamsFromLib("terkk$eliminatorkapi$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_eliminatorkapi_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 4 kolicina=IF(G19<=1825,2,IF(G19<=2400,3,4)) 
  // derivat local 4
  _derivat_key = "P 113";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$derivat1',
    virtelclass: "terkk$eliminatorkapi$profil",
    kolicina: 0, // ???
  };
  x.kolicina = XIF(G19 <= 1825, 2, XIF(G19 <= 2400, 3, 4));
  // duzina =F19-60
  x.duzina = F19 - 60;
  // x.calculated_ident = 'PP113AA000006000';
  x.calculated_ident = 'PP113AA00000';
  x.naziv = 'PROFIL AL ELIMINATOR KAPI P 113  P113 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  // x.tip = 'PP113AA000006000';
  x.tip = 'PP113AA00000'; // DL 2023-05-29 uklonjen sufix 6000.
  x = {
    ...x,
    ..._getParamsFromLib("terkk$eliminatorkapi$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 4.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_eliminatorkapi_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 5 kolicina=IF(E9=610,14,IF(E9=915,21,IF(E9=1220,29,"Ne valja dužina")))
  // derivat local 5
  _derivat_key = "PP 106";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$derivat1',
    virtelclass: "terkk$eliminatorkapi$profil",
    kolicina: 0, // ???
  };
  // x.kolicina = XIF(E9 === 610, 14, XIF(E9 === 915, 21, XIF(E9 === 1220, 29, "Ne valja dužina")));
  // x.kolicina = (v_input.sirinaelk - 77) / 44; // DL 2023-03-31: Zaokruziti na prvu vecu
  // x.kolicina = terUtilsNumberRoundUp(((v_input.sirinaelk - 77) / 44), 0); // DL 2023-03-31: Zaokruziti na prvu vecu
  x.kolicina = terUtilsNumberRoundUp(((v_input.sirinaelk - 77) / 40), 0); // DL 2023-00-02: Podeliti sa 40 i zaokruziti na prvi veci ceo broj.
  // duzina = G19-60
  x.duzina = G19 - 60;
  // x.calculated_ident = 'PP106AA000006000';
  x.calculated_ident = 'PP106AA00000';
  x.naziv = 'PROFIL PVC ELIMINATOR KAPI PP106 P106 SIROV';
  _materijal_naziv = x.naziv;
  x._materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.tip = x.calculated_ident;
  x = {
    ...x,
    ..._getParamsFromLib("terkk$eliminatorkapi$profil")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 5.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_eliminatorkapi_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 6
  // derivat local 6 MATERIJAL
  _derivat_key = "A 140";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    kolicina: 4,
    duzina: 0,
    tip: ''
  };
  x.calculated_ident = 'B100010000000008';
  x.naziv = 'OSTALO ELIMINATOR KAPI ROGALJ A 140';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 7 
  // derivat local 7 MATERIJAL
  // _derivat_key = "G65";
  _derivat_key = "G003 F 1"; // B100010000000071 - OSTALO ZAPTIVAČI G003 F 1
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M,
    // kolicina: 1,
    tip: '',
  };
  x.kolicina = (4 * v_input.visinaelk) / 1000; // Formaula za kolicinu je 4*visina eliminatora . Jedinica mere je metar m // delimo sa 1000 da dobijemo metre
  // duzina =E23
  // x.duzina = E23;
  x.duzina = G19 - 44;
  // x.calculated_ident = 'B100010000000068';
  x.calculated_ident = 'B100010000000071';
  // x.naziv = 'OSTALO ZAPTIVACI G 65';
  x.naziv = 'OSTALO ZAPTIVAČI G003 F 1';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 8 
  // derivat local 8 MATERIJAL
  _derivat_key = "N826";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$eliminatorkapi$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_KOM,
    tip: ''
  };
  // kolicina =IF(G19<=1835,(ROUNDUP(((F19-77)/40)/7,0))*4,IF(G19<=2400,(ROUNDUP(((F19-77)/40)/7,0))*6,(ROUNDUP(((F19-77)/40)/7,0))*8))
  x.kolicina = XIF(G19 <= 1835, (ROUNDUP(((F19 - 77) / 40) / 7, 0)) * 4, XIF(G19 <= 2400, (ROUNDUP(((F19 - 77) / 40) / 7, 0)) * 6, (ROUNDUP(((F19 - 77) / 40) / 7, 0)) * 8));
  x.calculated_ident = 'B100010000000009';
  x.naziv = 'OSTALO ELIMINATOR KAPI NOSAC N 826';
  x.duzina = 0;
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


const _derivat_eliminatorkapi_materijal1_by_pp = (p) => {
  // ovo su materijali koji se prave za svaki derivat OD 1 DO 5.

  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  // PODS INPUT ZA METERIJAL
  const _materijal_naziv = p._materijal_naziv;
  const tip = p.tip;
  const duzina = p.duzina;
  const v_input = {
    tip,
    duzina,
    _materijal_naziv
  };

  // dodajem mu materijal!
  // let z;
  let x = {
    naziv: v_input._materijal_naziv
  };
  x.calculated_ident = v_input.tip;
  x.terkategorija = 'M';
  let _kolicina = v_input.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
  x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
  x.jm = tclocal.JM_M;
  // z["derivat2"] = x;
  // posto materijal nece na backendu da se cuva odmah ovde delimicno kompletiramo virtel plitki
  const virtel_plitki_materijal = {
    // ...v_input,
    ...x
  };
  return virtel_plitki_materijal;

  // TODO: ovde imamo dva puta polje kolicina
};

